// Previous/next chevrons for the product gallery. The buttons inside invoke this element with
// commandfor + command="--prev" / "--next"; it scrolls the target gallery by one photo.
// s-gallery-loop handles wrapping from the last photo back to the first.
class GalleryNav extends HTMLElement {
  #abort = null;

  connectedCallback() {
    const scope = this.closest(this.dataset.scope || 'body') || document.body;
    this.target = scope.querySelector(this.dataset.target);
    if (!this.target) return;

    this.#abort = new AbortController();
    this.addEventListener('command', (event) => this.#onCommand(event), { signal: this.#abort.signal });
  }

  disconnectedCallback() {
    this.#abort?.abort();
  }

  #onCommand(event) {
    if (event.command !== '--prev' && event.command !== '--next') return;
    const slide = this.target.firstElementChild;
    const gap = parseFloat(getComputedStyle(this.target).columnGap) || 0;
    const step = (slide?.getBoundingClientRect().width || this.target.clientWidth) + gap;
    const rtl = getComputedStyle(this.target).direction === 'rtl';
    let direction = event.command === '--next' ? 1 : -1;
    if (rtl) direction *= -1;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const behavior = reduceMotion ? 'instant' : 'smooth';
    // With two photos in view the last photo can't reach the leading edge, so "next" at the end goes back to the first photo.
    const max = this.target.scrollWidth - this.target.clientWidth;
    const atEnd = Math.abs(this.target.scrollLeft) >= max - 2;
    if (event.command === '--next' && atEnd) {
      const firstOffset = this.target.dataset.loopOffset ? step : 0;
      this.target.scrollTo({ left: firstOffset * (rtl ? -1 : 1), behavior });
      return;
    }
    this.target.scrollBy({ left: step * direction, behavior });
  }
}

if (!customElements.get('s-gallery-nav')) {
  customElements.define('s-gallery-nav', GalleryNav);
}
